<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableCustomerDefinedAlarmConfigurationDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <!-- 例外资源 -->
        <Button
          type="primary"
          size="small"
          @click="exceptionResource(row)"
          v-hasPermission="[
            'configurationManagement:customerDefinedAlarmConfiguration:except_resource'
          ]"
          v-if="
            row.monitorModule === 0 ||
              row.monitorModule === 11 ||
              row.monitorModule === 1 ||
              row.monitorModule === 27 ||
              row.monitorModule === 6
          "
        >
          {{ $t("ApprovalTask.view") }}</Button
        >
      </template>
      <template slot-scope="{ row, index }" slot="configuration">
        <!-- 例外资源 -->
        <Button
          v-if="companyIdCookie == 1"
          type="info"
          size="small"
          @click="showAIConfigure(row)"
        >
          {{ $t("common.configure") }}</Button
        >
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal
      v-model="showEditAI"
      width="800"
      :title="$t('configuration_management.customized_alarm_config.configureSeparateAIAlarmProcess')"
      footer-hide
    >
      <div>
        <Card>
          <div style="font-weight: 700;">{{ aiItemData.priorityShowName }}</div>
          <div style="margin-top: 10px;">
            <div>{{ $t('configuration_management.customized_alarm_config.pleaseEnterTheProcessContent') }}</div>
            <Input v-model="processContent" type="textarea" :rows="3" :placeholder="$t('permission_configuration_management.common.pleaseInput')" />
            <div style="display: flex; align-items: flex-start; justify-content: space-between; margin-top: 12px;">
              <Button :loading="aiLoading" type="primary" @click="aiIdentification">{{ $t('configuration_management.customized_alarm_config.identification') }}</Button>
              <div v-if="aiTips" style="margin-left: 16px; flex: 1;">
                <span style="font-weight: 700; color: #ed4014;">*{{ $t('Bill.ResourceOptimization.prompt') }}：</span>
                <span style="color: #ed4014;">{{ aiTips }}</span>
              </div>
            </div>
            <div v-if="sopSteps.length > 0" class="sop-timeline-wrap" style="margin-top: 16px;">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                <span style="font-weight: 600;">{{ $t('configuration_management.customized_alarm_config.processStepList') }}</span>
                <span style="color: #808695; font-size: 12px;">{{ $t('configuration_management.customized_alarm_config.maxSteps') }}</span>
              </div>
              <draggable v-model="sopSteps" handle=".sop-step-handle" class="sop-step-list">
                <div v-for="(val, index) in sopSteps" :key="val.stepId || ('step-' + index)" class="sop-step-row">
                  <span class="sop-step-handle">≡</span>
                  <div class="sop-step-dot">{{ index + 1 }}</div>
                  <Input
                    v-model="sopSteps[index].stepInfo"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 3 }"
                    style="flex: 1;"
                    :placeholder="$t('configuration_management.customized_alarm_config.pleaseEnterStepContent')"
                  />
                  <Button size="small" type="text" style="color: #ed4014;" @click="deleteStep(index)">
                    <Icon type="md-trash" />
                  </Button>
                </div>
              </draggable>
              <Button v-if="sopSteps.length < 15" type="dashed" long style="margin-top: 8px;" @click="addStep">
                <Icon type="md-add" /> {{ $t('configuration_management.customized_alarm_config.addStep') }}
              </Button>
            </div>
          </div>
        </Card>
        <Card style="margin-top: 10px">
          <div>{{ $t('configuration_management.customized_alarm_config.pleaseConfigureTheNotificationTemplate') }}</div>
          <div style="margin-top: 10px">
            <Table border :columns="tableColumns" :data="aiItemData.sopEmailTemplates"></Table>
          </div>
        </Card>
        <div style="text-align: right; margin-top: 16px;">
          <Button @click="showEditAI = false">{{ $t('BillingServices.cancel') }}</Button>
          <Button type="primary" style="margin-left: 8px;" @click="submitSopItem">{{ $t('common.ok') }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import TableExpand from "../customer_defined_alarm_configuration/TableExpand.vue";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";
import draggable from 'vuedraggable';

var tableCustomerDefinedAlarmConfigurationVue = {};
export default {
  name: "TableCustomerDefinedAlarmConfiguration",
  components: {
    ConfigurationManagementOperationLog,
    draggable
  },
  data() {
    return {
      companyIdCookie: undefined,
      noticeTypes: [],
      noticeTypeList: [],
      isShowOperationLog: false,
      logGroupName: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      editIndex: -1,
      editFinalVersionCustomerMonitorIndexDefaultValue: "",
      editCustomerPriorityName: "",
      monitorPeriod: "",
      editAccountGroupIds: [],
      editCloudTrailNames: [],
      monitorPeriodList: [],
      editFinalVersionCustomerMonitorIndexDefaultValues: [],
      editIsAutoDelayEnroll: "",
      alertRulePeriodValidity: "",
      editProcessTemplateId: "",
      val: "",
      name: "",
      // 新增筛选条件值
      monitorModule: null,
      monitorIndex: null,
      priority: null,
      queryState: null,
      queryAiMonitorAlertStatus: null,
      // 优先级别
      priorityList: [
        {
          key: "P1",
          value: "P1"
        },
        {
          key: "P2",
          value: "P2"
        },
        {
          key: "P3",
          value: "P3"
        },
        {
          key: "P4",
          value: "P4"
        }
      ],
      accountGroupList: [],
      cloudTrailNamesList: [],
      thresholdValueList: [],
      // Enroll
      isAutoDelayEnrollList: [
        {
          key: this.$t("alarm_contact.yes"),
          value: "true"
        },
        {
          key: this.$t("alarm_contact.no"),
          value: "false"
        }
      ],
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("configuration_management.common.sequenceId"),
          key: "sequenceName",
          minWidth: 100
        },
        {
          title: this.$t("configuration_management.common.accountType"),
          key: "accountTypeName",
          minWidth: 90
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName",
          minWidth: 120
        },
        {
          title: this.$t(
            "configuration_management.customized_alarm_config.defaultApprovalFlow"
          ),
          key: "processTemplateName",
          minWidth: 150,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              if (
                row.monitorIndex == 12 ||
                row.monitorIndex == 35 ||
                row.monitorIndex == 36 ||
                row.monitorIndex == 40
              ) {
                this.editProcessTemplateId = row.processTemplateId;
                let options = row.processTemplates.map(v => {
                  return h(
                    "Option",
                    {
                      props: {
                        value: v.id
                      }
                    },
                    v.name
                  );
                });
                edit = [
                  h(
                    "Select",
                    {
                      props: {
                        value: row.processTemplateId,
                        transfer: true
                      },
                      on: {
                        "on-change": val => {
                          this.editProcessTemplateId = val;
                        }
                      }
                    },
                    options
                  )
                ];
              }
            } else {
              edit = row.processTemplateName;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("configuration_management.common.monitorModule"),
          key: "monitorModuleName",
          minWidth: 120
        },
        {
          title: this.$t("configuration_management.common.threshold"),
          key: "customerMonitorIndexDefaultValue",
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            // 当单位为“%”时 阈值填写最小为1 最大为100
            if (
              tableCustomerDefinedAlarmConfigurationVue.editIndex === index &&
              row.unitName == "%"
            ) {
              this.editFinalVersionCustomerMonitorIndexDefaultValue =
                row.customerMonitorIndexDefaultValue;
              edit = [
                h("InputNumber", {
                  props: {
                    value: Number(row.customerMonitorIndexDefaultValue),
                    max: 100,
                    min: 1
                  },
                  style: {
                    width: "60px"
                  },
                  on: {
                    input: val => {
                      this.editFinalVersionCustomerMonitorIndexDefaultValue = val;
                    }
                  }
                })
              ];
            } else if (
              tableCustomerDefinedAlarmConfigurationVue.editIndex === index
            ) {
              // 当监控指标为“RI匹配”时 不能编辑阈值 其余可以编辑
              if (row.monitorIndex != 15) {
                this.editFinalVersionCustomerMonitorIndexDefaultValue =
                  row.customerMonitorIndexDefaultValue;
                edit = [
                  h("Input", {
                    props: {
                      value: row.customerMonitorIndexDefaultValue,
                      type: "number"
                    },
                    style: {
                      width: "60px"
                    },
                    on: {
                      input: val => {
                        this.editFinalVersionCustomerMonitorIndexDefaultValue = val;
                      }
                    }
                  })
                ];
              }
              // 当监控指标为“自动购买预留实例”时 阈值显示多选且能添加文本框
              if (row.monitorIndex == 40) {
                this.editFinalVersionCustomerMonitorIndexDefaultValues =
                  row.customerMonitorIndexDefaultStringValues;
                let options = row.thresholdValueList.map(v => {
                  return h(
                    "Option",
                    {
                      props: {
                        value: v.value
                      }
                    },
                    v.label
                  );
                });
                edit = [
                  h(
                    "Select",
                    {
                      props: {
                        value: row.customerMonitorIndexDefaultStringValues,
                        transfer: true,
                        multiple: true,
                        filterable: true,
                        allowCreate: true
                      },
                      on: {
                        "on-change": val => {
                          this.editFinalVersionCustomerMonitorIndexDefaultValues = val;
                        },
                        "on-create": val => {
                          if (val >= 2 && val <= 60) {
                            row.thresholdValueList.push({
                              value: val,
                              label: val
                            });
                          } else {
                            row.customerMonitorIndexDefaultStringValues = [];
                            this.$Modal.warning({
                              title: this.$t("configuration_management.customized_alarm_config.validationRule"),
                              content:
                                this.$t("configuration_management.customized_alarm_config.thresholdRangeForAutoRI")
                            });
                          }
                        },
                        input: e => {
                          if (e.length > 6) {
                            row.customerMonitorIndexDefaultStringValues = [];
                            this.$Modal.warning({
                              title: this.$t("configuration_management.customized_alarm_config.validationRule"),
                              content: this.$t("configuration_management.customized_alarm_config.maxSixThresholds")
                            });
                          }
                        }
                      }
                    },
                    options
                  )
                ];
              }
            } else {
              if (row.customerMonitorIndexDefaultValue) {
                edit = row.customerMonitorIndexDefaultValue;
              } else if (row.customerMonitorIndexDefaultStringValue) {
                edit = row.customerMonitorIndexDefaultStringValue;
              }
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("configuration_management.common.priority"),
          key: "customerPriorityName",
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              this.editCustomerPriorityName = row.customerPriorityName;
              let options = this.priorityList.map(v => {
                return h(
                  "Option",
                  {
                    props: {
                      value: v.value
                    }
                  },
                  v.key
                );
              });
              edit = [
                h(
                  "Select",
                  {
                    props: {
                      value: row.customerPriorityName,
                      transfer: true
                    },
                    on: {
                      "on-change": val => {
                        this.editCustomerPriorityName = val;
                      }
                    }
                  },
                  options
                )
              ];
            } else {
              edit = row.customerPriorityName;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t(
            "configuration_management.customized_alarm_config.isAutoDelayEnroll"
          ),
          key: "isAutoDelayEnroll",
          minWidth: 110,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              if (row.isAutoDelayEnroll == this.$t("common.yes")) {
                row.isAutoDelayEnroll = "true";
              } else if (row.isAutoDelayEnroll == this.$t("common.no")) {
                row.isAutoDelayEnroll = "false";
              }
              this.editIsAutoDelayEnroll = row.isAutoDelayEnroll;
              let options = this.isAutoDelayEnrollList.map(v => {
                return h(
                  "Option",
                  {
                    props: {
                      value: v.value
                    }
                  },
                  v.key
                );
              });
              edit = [
                h(
                  "Select",
                  {
                    props: {
                      value: row.isAutoDelayEnroll,
                      transfer: true
                    },
                    on: {
                      "on-change": val => {
                        this.editIsAutoDelayEnroll = val;
                      }
                    }
                  },
                  options
                )
              ];
            } else {
              edit = row.isAutoDelayEnroll;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t(
            "configuration_management.customized_alarm_config.alarmValidityPeriod"
          ),
          key: "alertRulePeriodValidity",
          minWidth: 120,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              this.alertRulePeriodValidity = row.alertRulePeriodValidity;
              edit = [
                h("InputNumber", {
                  props: {
                    value: Number(row.alertRulePeriodValidity),
                    max: 7488,
                    min: 1
                  },
                  style: {
                    width: "100px"
                  },
                  on: {
                    input: val => {
                      this.alertRulePeriodValidity = val;
                    }
                  }
                })
              ];
            } else {
              edit = row.alertRulePeriodValidity;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("configuration_management.common.monitorPeriod"),
          key: "monitorPeriodName",
          minWidth: 150,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              this.monitorPeriodName = row.monitorPeriodName;
              let options = this.monitorPeriodList.map(v => {
                return h(
                  "Option",
                  {
                    props: {
                      value: v.id
                    }
                  },
                  v.name
                );
              });
              edit = [
                h(
                  "Select",
                  {
                    props: {
                      value: row.monitorPeriod,
                      transfer: true
                    },
                    on: {
                      "on-change": val => {
                        this.monitorPeriod = val;
                      }
                    }
                  },
                  options
                )
              ];
            } else {
              edit = row.monitorPeriodName;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t(
            "configuration_management.customized_alarm_config.noticeType"
          ),
          key: "noticeTypesName",
          minWidth: 150,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              this.noticeTypesName = row.noticeTypesName;
              let options = this.noticeTypeList.map(v => {
                return h(
                  "Option",
                  {
                    props: {
                      value: v.id
                    }
                  },
                  v.name
                );
              });
              edit = [
                h(
                  "Select",
                  {
                    props: {
                      value: row.noticeTypes,
                      transfer: true,
                      multiple: true,
                      filterable: true,
                      allowCreate: true
                    },
                    on: {
                      "on-change": val => {
                        this.noticeTypes = val;
                      }
                    }
                  },
                  options
                )
              ];
            } else {
              edit = row.noticeTypesName;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t(
            "AlertConfigManagement.CostomizedAlarm.isAccountGroup"
          ),
          key: "defaultAlarmAccountType",
          minWidth: 120
        },
        {
          title: this.$t(
            "AlertConfigManagement.CostomizedAlarm.AccountGroupName"
          ),
          key: "accountGroupIdList",
          minWidth: 180,
          render: (h, { row, index }) => {
            let edit;
            if (
              tableCustomerDefinedAlarmConfigurationVue.editIndex === index &&
              row.defaultAlarmAccountType == this.$t("common.accountGroup")
            ) {
              this.editAccountGroupIds = row.accountGroupIdList;
              let options = this.accountGroupList.map(v => {
                return h(
                  "Option",
                  {
                    props: {
                      value: v.id
                    }
                  },
                  v.accountGroupName
                );
              });
              edit = [
                h(
                  "Select",
                  {
                    props: {
                      value: row.accountGroupIdList,
                      transfer: true,
                      multiple: true
                    },
                    on: {
                      "on-change": val => {
                        this.editAccountGroupIds = val;
                      }
                    }
                  },
                  options
                )
              ];
            } else {
              edit = row.accountGroupNames;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("configuration_management.common.logGroupName"),
          key: "logGroupName",
          minWidth: 180,
          render: (h, { row, index }) => {
            let edit;
            if (
              tableCustomerDefinedAlarmConfigurationVue.editIndex === index &&
              row.monitorIndex == 59
            ) {
              this.logGroupName = row.logGroupName;
              let options = row.logGroupName;
              edit = [
                h(
                  "Input",
                  {
                    props: {
                      value: row.logGroupName
                    },
                    on: {
                      input: val => {
                        this.logGroupName = val;
                      }
                    }
                  },
                  options
                )
              ];
            } else {
              edit = row.logGroupName;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("alarms.log.cloudTrail.eventCheck"),
          key: "cloudTrailNames",
          minWidth: 300,
          render: (h, { row, index }) => {
            let edit;
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              if (row.monitorIndex == 54) {
                this.editCloudTrailNames = row.cloudTrailNames;
                let options = this.cloudTrailNamesList.map(v => {
                  return h(
                    "Option",
                    {
                      props: {
                        value: v.awsEventName
                      }
                    },
                    v.awsEventName
                  );
                });
                edit = [
                  h(
                    "Select",
                    {
                      props: {
                        value: row.cloudTrailNames,
                        transfer: true,
                        multiple: true,
                        maxTagCount: 1
                      },
                      on: {
                        "on-change": val => {
                          this.editCloudTrailNames = val;
                        }
                      }
                    },
                    options
                  )
                ];
              }
            } else {
              edit = row.cloudTrailName;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("AlertConfigManagement.CostomizedAlarm.status"),
          key: "state",
          fixed: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    type: "primary",
                    size: "large",
                    // 当监控指标为“RI匹配”和“RI到期”时,禁止点击
                    value: params.row.state,
                    disabled:
                      params.row.monitorIndex == 15 ||
                      params.row.monitorIndex == 13
                        ? true
                        : false
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:customerDefinedAlarmConfiguration:changeStatus"
                      )
                    }
                  ]
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.account.enable"
                      )
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.account.disable"
                      )
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t(
            "configuration_management.customized_alarm_config.exceptionResources"
          ),
          slot: "detail",
          fixed: "right",
          minWidth: 100
        },
        {
          title: this.$t(
            "permission_configuration_management.account.operationLog"
          ),
          slot: "delete",
          fixed: "right",
          minWidth: 120,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.rowClick(params.row);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:customerDefinedAlarmConfiguration:log"
                      )
                    }
                  ]
                },
                this.$t(
                  "permission_configuration_management.account.operationLog"
                )
              )
            ]);
          }
        },
        {
          title: this.$t("common.operation"),
          minWidth: 130,
          fixed: "right",
          render: (h, { row, index }) => {
            if (tableCustomerDefinedAlarmConfigurationVue.editIndex === index) {
              return [
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].customerMonitorIndexDefaultValue = this.editFinalVersionCustomerMonitorIndexDefaultValue;
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].customerPriorityName = this.editCustomerPriorityName;
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].accountGroupIdList = this.editAccountGroupIds;
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].cloudTrailNames = this.editCloudTrailNames;

                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].customerMonitorIndexDefaultStringValues = this.editFinalVersionCustomerMonitorIndexDefaultValues;
                        // enroll
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].isAutoDelayEnroll = this.editIsAutoDelayEnroll;
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].alertRulePeriodValidity = this.alertRulePeriodValidity;
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].processTemplateId = this.editProcessTemplateId;

                        // 通知方式
                        this.tableCustomerDefinedAlarmConfigurationDate[
                          index
                        ].noticeTypes = this.noticeTypes;
                        tableCustomerDefinedAlarmConfigurationVue.editIndex = -1;

                        var editList = {
                          id: row.id,
                          logGroupName: this.logGroupName,
                          customerPriorityName: this.editCustomerPriorityName,
                          accountGroupIdList: this.editAccountGroupIds,
                          customerMonitorIndexDefaultValue: this
                            .editFinalVersionCustomerMonitorIndexDefaultValue,
                          resourceType: row.resourceType,
                          monitorPeriod: this.monitorPeriod,
                          isAutoDelayEnroll: this.editIsAutoDelayEnroll,
                          alertRulePeriodValidity: this.alertRulePeriodValidity,
                          noticeTypes: this.noticeTypes
                        };

                        // 如果监控指标为实例健康状态或者系统健康状态
                        if (row.monitorIndex == 40) {
                          editList.customerMonitorIndexDefaultStringValues = this.editFinalVersionCustomerMonitorIndexDefaultValues;
                        } else {
                          editList.customerMonitorIndexDefaultValue = this.editFinalVersionCustomerMonitorIndexDefaultValue;
                        }

                        // 当指标为"EIP没有EC2attached"、"自动购买预留实例"、"没有EBS attached"、"负载均衡未关联实例"时 传审批流
                        if (
                          row.monitorIndex == 12 ||
                          row.monitorIndex == 35 ||
                          row.monitorIndex == 36 ||
                          row.monitorIndex == 40
                        ) {
                          editList.processTemplateId = this.editProcessTemplateId;
                        }

                        //当指标为"CloudTrail异常事件"时 传事件检查
                        if (row.monitorIndex == 54) {
                          editList.cloudTrailNames = this.editCloudTrailNames;
                        }

                        // 编辑接口
                        this.$api.customerDefinedAlarmConfiguration
                          .updateCustomAlertRule(editList)
                          .then(res => {
                            setTimeout(() => {
                              tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
                              this.$Message.success(this.$t("configuration_management.customized_alarm_config.editSuccess"));
                            }, 1000);
                          });
                      }
                    },
                    directives: [
                      {
                        name: "hasPermission",
                        value: new Array(
                          "configurationManagement:customerDefinedAlarmConfiguration:edit"
                        )
                      }
                    ]
                  },
                  this.$t("configuration_management.common.save")
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginLeft: "6px"
                    },
                    on: {
                      click: () => {
                        tableCustomerDefinedAlarmConfigurationVue.editIndex = -1;
                        tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
                      }
                    }
                  },
                  this.$t("alarms.common.cancel")
                )
              ];
            } else {
              return h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.editFinalVersionCustomerMonitorIndexDefaultValue =
                        row.customerMonitorIndexDefaultValue;
                      this.editFinalVersionCustomerMonitorIndexDefaultValues =
                        row.customerMonitorIndexDefaultStringValues;
                      this.editCustomerPriorityName = row.customerPriorityName;
                      this.editAccountGroupIds = row.accountGroupIdList;
                      this.editIsAutoDelayEnroll = row.isAutoDelayEnroll;
                      this.editProcessTemplateId = row.processTemplateId;
                      this.editCloudTrailNames = row.cloudTrailNames;
                      tableCustomerDefinedAlarmConfigurationVue.editIndex = index;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:customerDefinedAlarmConfiguration:edit"
                      )
                    }
                  ]
                },
                this.$t("common.edit")
              );
            }
          }
        },
        {
          title: this.$t(
            "configuration_management.customized_alarm_config.AIMonitoringAlarm"
          ),
          slot: "configuration",
          fixed: "right",
          minWidth: 100
        },
        {
          title: this.$t("configuration_management.customized_alarm_config.AIMonitorsTheAlarmStatus"),
          key: "state",
          fixed: "right",
          minWidth: 100,
          render: (h, params) => {
            if (getCookie(global.companyId) == 1) {
              return h("div", [
                h(
                  "i-switch",
                  {
                    props: {
                      type: "primary",
                      size: "large",
                      value: params.row.aiMonitorAlertStatus
                    },
                    on: {
                      "on-change": () => {
                        this.switchAi(params.index);
                      }
                    },
                    directives: [
                      {
                        name: "hasPermission",
                        value: new Array(
                          "configurationManagement:customerDefinedAlarmConfiguration:changeStatus"
                        )
                      }
                    ]
                  },
                  [
                    h("span", {
                      slot: "open",
                      domProps: {
                        innerHTML: this.$t(
                          "permission_configuration_management.account.enable"
                        )
                      }
                    }),
                    h("span", {
                      slot: "close",
                      domProps: {
                        innerHTML: this.$t(
                          "permission_configuration_management.account.disable"
                        )
                      }
                    })
                  ]
                )
              ]);
            }
          }
        }
      ],
      newTableECDateList: [],
      tableCustomerDefinedAlarmConfigurationDate: [],
      showEditAI: false,
      processContent: '',
      // 编辑状态记录，格式为 { rowIndex_field: boolean }
      editingState: {},
      tableColumns: [
        {
          title: this.$t('message.templateName'),
          key: 'templateName',
          width: 100,
          render: (h, params) => {
            return h('div', {
              // on: {
              //   dblclick: () => {
              //     this.startEdit(params.index, 'templateName');
              //   }
              // },
              // style: {
              //   cursor: 'pointer',
              //   minHeight: '30px',
              //   lineHeight: '30px'
              // }
            }, params.row.templateName);
          }
        },
        {
          title: this.$t('configuration_management.customized_alarm_config.recipient'),
          slot: 'recipient',
          width: 150,
          render: (h, params) => {
            // 获取当前单元格的编辑状态
            const editingKey = `${params.index}_recipient`;
            const isEditing = this.editingState[editingKey];
            if (isEditing) {
              return h('Input', {
                props:{
                  type:'text',
                  value: params.row.recipient
                },
                on: {
                  input: (event) => {
                    this.$set(this.aiItemData.sopEmailTemplates, params.index, {
                      id: params.row.id,
                      templateName: params.row.templateName,
                      recipient: event,
                      subjectMode: params.row.subjectMode,
                      subjectSuffix: params.row.subjectSuffix,
                      subject: params.row.subject,
                      templateContent: params.row.templateContent
                    });
                  },
                  'on-blur': () => {
                    this.saveEdit(params.index, 'recipient');
                  }
                }
              });
            } else {
              return h('div', {
                on: {
                  dblclick: () => {
                    this.startEdit(params.index, 'recipient');
                  }
                },
                style: {
                  cursor: 'pointer',
                  minHeight: '30px',
                  lineHeight: '30px'
                }
              }, params.row.recipient);
            }
          }
        },
        {
          title: this.$t('configuration_management.customized_alarm_config.subjectMode'),
          slot: 'subjectMode',
          width: 130,
          render: (h, params) => {
            const currentMode = params.row.subjectMode === 1 ? 1 : 0;
            return h('Select', {
              props: {
                value: currentMode,
                transfer: true
              },
              on: {
                'on-change': (event) => {
                  this.$set(this.aiItemData.sopEmailTemplates, params.index, {
                    id: params.row.id,
                    templateName: params.row.templateName,
                    recipient: params.row.recipient,
                    subjectMode: event,
                    subjectSuffix: params.row.subjectSuffix,
                    subject: params.row.subject,
                    templateContent: params.row.templateContent
                  });
                }
              }
            }, [
              h('Option', {
                props: { value: 0 }
              }, this.$t('configuration_management.customized_alarm_config.subjectModeSuffix')),
              h('Option', {
                props: { value: 1 }
              }, this.$t('configuration_management.customized_alarm_config.subjectModeReplace'))
            ]);
          }
        },
        {
          title: this.$t('configuration_management.customized_alarm_config.subjectSuffix'),
          slot: 'subjectSuffix',
          width: 180,
          render: (h, params) => {
            // 主题模式为整体替换(1)时，展示邮件主题(subject)输入；否则展示主题后缀(subjectSuffix)
            const isReplaceMode = params.row.subjectMode === 1;
            const field = isReplaceMode ? 'subject' : 'subjectSuffix';
            const editingKey = `${params.index}_${field}`;
            const isEditing = this.editingState[editingKey];
            const value = isReplaceMode ? params.row.subject : params.row.subjectSuffix;
            if (isEditing) {
              return h('Input', {
                props:{
                  type:'text',
                  value: value
                },
                on: {
                  input: (event) => {
                    this.$set(this.aiItemData.sopEmailTemplates, params.index, {
                      id: params.row.id,
                      templateName: params.row.templateName,
                      recipient: params.row.recipient,
                      subjectMode: params.row.subjectMode,
                      subjectSuffix: isReplaceMode ? params.row.subjectSuffix : event,
                      subject: isReplaceMode ? event : params.row.subject,
                      templateContent: params.row.templateContent
                    });
                  },
                  'on-blur': () => {
                    this.saveEdit(params.index, field);
                  }
                }
              });
            } else {
              return h('div', {
                on: {
                  dblclick: () => {
                    this.startEdit(params.index, field);
                  }
                },
                style: {
                  cursor: 'pointer',
                  minHeight: '30px',
                  lineHeight: '30px'
                }
              }, value);
            }
          }
        },
        {
          title: this.$t('alarms.common.emailTemplate'),
          slot: 'templateContent',
          render: (h, params) => {
            // 获取当前单元格的编辑状态
            const editingKey = `${params.index}_templateContent`;
            const isEditing = this.editingState[editingKey];
            if (isEditing) {
              return h('Input', {
                props:{
                  type:'textarea',
                  rows: 3,
                  value: params.row.templateContent
                },
                on: {
                  input: (event) => {
                    this.$set(this.aiItemData.sopEmailTemplates, params.index, {
                      id: params.row.id,
                      templateName: params.row.templateName,
                      recipient: params.row.recipient,
                      subjectMode: params.row.subjectMode,
                      subjectSuffix: params.row.subjectSuffix,
                      subject: params.row.subject,
                      templateContent: event
                    });
                  },
                  'on-blur': () => {
                    this.saveEdit(params.index, 'templateContent');
                  }
                }
              });
            } else {
              return h('div', {
                on: {
                  dblclick: () => {
                    this.startEdit(params.index, 'templateContent');
                  }
                },
                style: {
                  cursor: 'pointer',
                  minHeight: '30px',
                  lineHeight: '30px'
                }
              }, params.row.templateContent);
            }
          }
        }
      ],
      aiItemData: {
        priorityShowName: '',
        sopEmailTemplates: []
      },
      aiTips: '',
      sopSteps: [],
      aiLoading: false,
      editingStepIndex: -1
    };
  },
  beforeCreate: function() {
    tableCustomerDefinedAlarmConfigurationVue = this;
  },
  mounted: function() {
    this.companyIdCookie = getCookie(global.companyId)
    tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
    tableCustomerDefinedAlarmConfigurationVue.listAccountGroup();
    tableCustomerDefinedAlarmConfigurationVue.searchMonitorPeriod();
    tableCustomerDefinedAlarmConfigurationVue.searchAlarmWay();
    tableCustomerDefinedAlarmConfigurationVue.queryCloudTrailSecurityEvents();
  },
  methods: {
    // 打开AI报警流程配置弹框
    showAIConfigure(e) {
      this.showEditAI = true
      this.processContent = ''
      this.aiTips = ''
      this.sopSteps = []
      this.editingStepIndex = -1
      this.$api.customerDefinedAlarmConfiguration.getSopDetail(e.id, e.companyId).then(res => {
        const arr = [
          {
            templateName: e.customerPriorityName + '-1',
            recipient: '',
            subjectMode: 0,
            subjectSuffix: '',
            subject: '',
            templateContent: ''
          },
          {
            templateName: e.customerPriorityName + '-2',
            recipient: '',
            subjectMode: 0,
            subjectSuffix: '',
            subject: '',
            templateContent: ''
          }
        ]
        if (res.data.data.sopEmailTemplates) {
          this.aiItemData = res.data.data
          this.aiItemData.sopEmailTemplates = (res.data.data.sopEmailTemplates || []).map(item => ({
            id: item.id,
            templateName: item.templateName,
            recipient: item.recipient || '',
            subjectMode: item.subjectMode === 1 ? 1 : 0,
            subjectSuffix: item.subjectSuffix || '',
            subject: item.subject || '',
            templateContent: item.templateContent || ''
          }))
          this.sopSteps = res.data.data.sopSteps || []
        } else {
          this.aiItemData.sopEmailTemplates = arr
          this.aiItemData.priorityShowName = e.customerPriorityName
          this.sopSteps = res.data.data.sopSteps || []
        }
        this.aiItemData.companyId = e.companyId
        this.aiItemData.priority = e.customerPriorityId
        this.aiItemData.customerMonitorItemId = e.id
      })
    },
    // ai识别
    aiIdentification() {
      if (!this.processContent) return
      this.aiLoading = true
      const data = {
        userInput: this.processContent,
        emailTemplateList: this.aiItemData.sopEmailTemplates.map(item => item.templateName)
      }
      this.$api.customerDefinedAlarmConfiguration.sopIdentify(data).then(res => {
        if (res.data.code !== 200) {
          this.aiTips = res.data.message
          this.sopSteps = []
        } else {
          this.aiTips = ''
          this.sopSteps = res.data.data
        }
      }).finally(() => {
        this.aiLoading = false
      })
    },
    addStep() {
      if (this.sopSteps.length >= 15) return
      this.sopSteps.push({ stepId: 'new_' + Date.now(), stepInfo: '' })
      this.editingStepIndex = this.sopSteps.length - 1
    },
    deleteStep(index) {
      if (this.sopSteps.length <= 1) {
        this.$Message.warning(this.$t('configuration_management.customized_alarm_config.atLeastOneStep'))
        return
      }
      this.sopSteps.splice(index, 1)
      if (this.editingStepIndex === index) this.editingStepIndex = -1
      else if (this.editingStepIndex > index) this.editingStepIndex--
    },
    moveStep(index, direction) {
      const target = index + direction
      if (target < 0 || target >= this.sopSteps.length) return
      const temp = this.sopSteps[index]
      this.$set(this.sopSteps, index, this.sopSteps[target])
      this.$set(this.sopSteps, target, temp)
      if (this.editingStepIndex === index) this.editingStepIndex = target
      else if (this.editingStepIndex === target) this.editingStepIndex = index
    },
    // 开始编辑
    startEdit(index, field) {
      const editingKey = `${index}_${field}`;
      this.$set(this.editingState, editingKey, true);
    },
    // 保存编辑
    saveEdit(index, field) {
      const editingKey = `${index}_${field}`;
      // 退出编辑状态
      this.$set(this.editingState, editingKey, false);
    },
    // 按主题模式裁剪邮件模板字段：追加后缀(0)不传 subject，整体替换(1)不传 subjectSuffix
    normalizeEmailTemplates(templates) {
      return (templates || []).map(item => {
        const result = Object.assign({}, item)
        if (result.subjectMode === 1) {
          delete result.subjectSuffix
        } else {
          delete result.subject
        }
        return result
      })
    },
    submitSopItem() {
      if (this.sopSteps.length <= 0) {
        this.$Message.error(this.$t('configuration_management.customized_alarm_config.stepsCannotBeEmpty'))
        return
      }
      const hasEmpty = this.sopSteps.some(s => !s.stepInfo || !s.stepInfo.trim())
      if (hasEmpty) {
        this.$Message.error(this.$t('configuration_management.customized_alarm_config.pleaseFillAllSteps'))
        return
      }
      const data = {
        companyId: this.aiItemData.companyId,
        customerMonitorItemId: this.aiItemData.customerMonitorItemId,
        defaultSopPriority: this.aiItemData.priority,
        sopEmailTemplates: this.normalizeEmailTemplates(this.aiItemData.sopEmailTemplates),
        sopSteps: this.sopSteps
      }
      this.$api.customerDefinedAlarmConfiguration.customerSop(data).then(res => {
        if (res.data.code === 200) {
          this.$Message.success(this.$t('configuration_management.customized_alarm_config.submitSuccess'))
          this.showEditAI = false
          this.getCustomerDefinedAlarmConfigurationData()
        } else {
          this.$Message.error(res.data.message)
        }
      })
    },
    // 查看例外资源
    exceptionResource: function(row) {
      this.$router.push({
        path: "/configurationManagement/exceptionResource",
        query: {
          id: row.id,
          monitorModule: row.monitorModule,
          monitorModuleName: row.monitorModuleName,
          accountTypeName: row.accountTypeName,
          type: row.type
        }
      });
    },
    //账户组列表
    listAccountGroup: function() {
      this.$api.accountGroup.listAccountGroup().then(res => {
        this.accountGroupList = res.data;
      });
    },
    // 查询CloudTrail事件
    queryCloudTrailSecurityEvents: function() {
      this.$api.cloudTrail.queryCloudTrailSecurityEvents().then(res => {
        this.cloudTrailNamesList = res.data;
      });
    },
    // 查询监控时间段
    searchMonitorPeriod: function() {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then(res => {
          this.monitorPeriodList = res.data;
        });
    },
    // 查询报警方式
    searchAlarmWay: function() {
      this.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then(res => {
          this.noticeTypeList = res.data;
        });
    },
    showIsAutoDelayEnroll: function() {
      if (
        this.tableCustomerDefinedAlarmConfigurationDate != null &&
        this.tableCustomerDefinedAlarmConfigurationDate != undefined &&
        this.tableCustomerDefinedAlarmConfigurationDate.length > 0
      ) {
        for (
          var i = 0;
          i < this.tableCustomerDefinedAlarmConfigurationDate.length;
          i++
        ) {
          // 注册自动延迟
          if (
            this.tableCustomerDefinedAlarmConfigurationDate[i]
              .isAutoDelayEnroll == true
          ) {
            this.tableCustomerDefinedAlarmConfigurationDate[
              i
            ].isAutoDelayEnroll = this.$t("alarm_contact.yes");
          } else if (
            this.tableCustomerDefinedAlarmConfigurationDate[i]
              .isAutoDelayEnroll == false
          ) {
            this.tableCustomerDefinedAlarmConfigurationDate[
              i
            ].isAutoDelayEnroll = this.$t("alarm_contact.no");
          }

          // 是否为账户组
          if (
            this.tableCustomerDefinedAlarmConfigurationDate[i]
              .defaultAlarmAccountType == 0
          ) {
            this.tableCustomerDefinedAlarmConfigurationDate[
              i
            ].defaultAlarmAccountType = this.$t("common.singleAccount");
          } else if (
            this.tableCustomerDefinedAlarmConfigurationDate[i]
              .defaultAlarmAccountType == 1
          ) {
            this.tableCustomerDefinedAlarmConfigurationDate[
              i
            ].defaultAlarmAccountType = this.$t("common.accountGroup");
          }
        }
      }
    },
    showAll: function() {
      tableCustomerDefinedAlarmConfigurationVue.editIndex = -1;
      tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
    },
    // 分页显示数据
    /****************************************************/
    getCustomerDefinedAlarmConfigurationData: function() {
      eventBus.$on("accountTypeNames", function(name) {
        tableCustomerDefinedAlarmConfigurationVue.name = name;
      });
      // 获取defaultAlarmConfigurationSearch里面的搜索内容
      eventBus.$on("companyId", function(val) {
        tableCustomerDefinedAlarmConfigurationVue.companyId = val;
      });
      // 监控模块
      eventBus.$on("monitorModule", function(val) {
        tableCustomerDefinedAlarmConfigurationVue.monitorModule = val;
      });
      // 监控指标
      eventBus.$on("monitorIndex", function(val) {
        tableCustomerDefinedAlarmConfigurationVue.monitorIndex = val;
      });
      // 优先级
      eventBus.$on("priority", function(val) {
        tableCustomerDefinedAlarmConfigurationVue.priority = val;
      });
      // 状态
      eventBus.$on("state", function(val) {
        tableCustomerDefinedAlarmConfigurationVue.queryState = val;
      });
      // AI 监控报警状态
      eventBus.$on("aiMonitorAlertStatus", function(val) {
        tableCustomerDefinedAlarmConfigurationVue.queryAiMonitorAlertStatus = val;
      });

      // 处理筛选值，去掉占位符 " "
      var trim = function(v) {
        if (v === undefined || v === null || v === " " || v === "") return null;
        return v;
      };
      // priority 选中"全部"传 -1，未选传 null
      var priorityVal = tableCustomerDefinedAlarmConfigurationVue.priority;
      var priorityParam;
      if (priorityVal === undefined || priorityVal === null || priorityVal === "") {
        priorityParam = null;
      } else if (priorityVal === " ") {
        priorityParam = -1;
      } else {
        priorityParam = priorityVal;
      }
      //分页
      this.$api.customerDefinedAlarmConfiguration
        .customAlertRulePage({
          companyId: tableCustomerDefinedAlarmConfigurationVue.companyId,
          type: tableCustomerDefinedAlarmConfigurationVue.name,
          monitorModule: trim(tableCustomerDefinedAlarmConfigurationVue.monitorModule),
          monitorIndex: trim(tableCustomerDefinedAlarmConfigurationVue.monitorIndex),
          priority: priorityParam,
          state: trim(tableCustomerDefinedAlarmConfigurationVue.queryState),
          aiMonitorAlertStatus: trim(tableCustomerDefinedAlarmConfigurationVue.queryAiMonitorAlertStatus),
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableCustomerDefinedAlarmConfigurationDate = res.data.records;
          if (
            res.data.current != null &&
            res.data.current != "" &&
            res.data.current != undefined
          ) {
            // 当前页
            this.current = res.data.current;
          } else {
            this.current = 1;
          }
          if (
            res.data.total != null &&
            res.data.total != "" &&
            res.data.total != undefined
          ) {
            // 总条数
            this.dataTotal = res.data.total;
          } else {
            this.dataTotal = 10;
          }
          tableCustomerDefinedAlarmConfigurationVue.showIsAutoDelayEnroll();
        });
    },
    changePage: function(current) {
      // change时行内编辑取消
      tableCustomerDefinedAlarmConfigurationVue.editIndex = -1;
      this.current = current;
      tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
    },
    changeSize: function(pageSize) {
      // change时行内编辑取消
      tableCustomerDefinedAlarmConfigurationVue.editIndex = -1;
      this.pageSize = pageSize;
      tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
    },
    beforeDestroy: function() {
      // 销毁accountTypeNames
      eventBus.$off("accountTypeNames");
      // 销毁companyId
      eventBus.$off("companyId");
      // 销毁新增的搜索条件事件
      eventBus.$off("monitorModule");
      eventBus.$off("monitorIndex");
      eventBus.$off("customerPriorityName");
      eventBus.$off("state");
      eventBus.$off("aiMonitorAlertStatus");
    },
    /**************************************switch**************************************/
    // switch
    switch(index) {
      this.index = index;
      // 打开是true,启用0 禁用1
      if (this.tableCustomerDefinedAlarmConfigurationDate[index].state) {
        this.changeStatusMessage(
          this.tableCustomerDefinedAlarmConfigurationDate[index].id,
          "state",
          false
        );
      } else {
        this.changeStatusMessage(
          this.tableCustomerDefinedAlarmConfigurationDate[index].id,
          "state",
          true
        );
      }
    },
    switchAi(i) {
      const data = {
        id: this.tableCustomerDefinedAlarmConfigurationDate[i].id,
        status: !this.tableCustomerDefinedAlarmConfigurationDate[i].aiMonitorAlertStatus
      }
      this.$api.customerDefinedAlarmConfiguration.changAiStatus(data).then(res => {
        this.$Message.success(this.$t('configuration_management.customized_alarm_config.modifySuccess'))
      }).finally(() => {
        this.getCustomerDefinedAlarmConfigurationData();
      })
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      this.$api.alertRuleConfiguration
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableCustomerDefinedAlarmConfigurationVue.getCustomerDefinedAlarmConfigurationData();
        });
    },
    // 操作日志
    rowClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          1
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
.sop-timeline-wrap {
  border: 1px solid #e8eaec;
  border-radius: 6px;
  padding: 12px 16px;
  background: #fafafa;
}
.sop-step-list {
  max-height: 400px;
  overflow-y: auto;
}
.sop-step-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.sop-step-row:last-child {
  border-bottom: none;
}
.sop-step-handle {
  color: #c5c8ce;
  font-size: 16px;
  cursor: grab;
  flex-shrink: 0;
}
.sop-step-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #2d8cf0;
  color: #fff;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/TableCustomerDefinedAlarmConfiguration.vue